module.exports = __webpack_public_path__ + "img/ANTENNA PALMA PURPLE.33e6257.svg";